export const version = '2.23.14';
//# sourceMappingURL=version.js.map